import { useRouter } from 'next/router';

import { GLOBAL_EVENT_QUERY } from '@/components/composite/Listeners/GlobalEventsListener';

import type { LinkHrefType } from '@/lib/menu/main';

const useFormatMenuLink = () => {
    const { asPath } = useRouter();

    const formatItemLink = (link: LinkHrefType): LinkHrefType => {
        if (typeof link === 'object' && Object.keys(link?.query).includes(GLOBAL_EVENT_QUERY)) {
            return { ...link, pathname: asPath };
        }
        return link;
    };

    return { formatItemLink };
};

export default useFormatMenuLink;
